import BaseModel from "./base/baseModel";

export default class ClienteTelefoneModel extends BaseModel {
    id?: number = null;
    clienteId?: number = null;
    telefone: string = null;
    padrao = false;
}
